let PHPHOST = ""
let MAPI = ""
let YLKAPI = ""
let USERAPI = ""
let API = ""
let MallApi = ""
let CDN = ""
let DEFAULT_SHOP_LOGO = ""
let ENV = ""
let EXAPI = ""
let EXAPI1 = ""
const host = window.location.host
if (host === "m.en.ylcool.com") {
  PHPHOST = "https://en.ylcool.com/" //生产环境
  MAPI = "https://m.ibuychem.com"
  YLKAPI = "https://m.en.ylcool.com/"
  USERAPI = "https://user.ibuychem.com/"
  API = "https://www.ibuychem.com/"
  MallApi = "https://en.ibuychem.com/"
  DEFAULT_SHOP_LOGO =
    "https://style.ibuychem.com/wiseshop/pc/images/en-default_goods.jpg"
  CDN = "https://wwwimg-cdn.ibuychem.com/"
  ENV = "production"
  EXAPI = "https://ex.hzeyun.com/"
  EXAPI1 = "https://www.hzeyun.com/"
} else {
  PHPHOST = "https://en-stg.ylcool.com/" //开发环境
  MAPI = "https://m-stg.ibuychem.com"
  YLKAPI = "https://m-stg-en.ylcool.com/"
  USERAPI = "https://user-stg.ibuychem.com/"
  API = "https://www-stg.ibuychem.com/"
  // API = 'https://www-stg2.ibuychem.com/';
  MallApi = "https://en-stg.ibuychem.com/"
  DEFAULT_SHOP_LOGO =
    "https://style-stg.ibuychem.com/wiseshop/pc/images/en-default_goods.jpg"
  ENV = "dev"
  EXAPI = "https://ex-stg.hzeyun.com/"
  EXAPI1 = "https://www-stg.hzeyun.com/"
  if (window.location.host === "m-stg.ylcool.com") {
    ENV = "test"
  } else {
    ENV = "dev"
  }
}

export default {
  MAPI,
  PHPHOST,
  YLKAPI,
  USERAPI,
  API,
  MallApi,
  DEFAULT_SHOP_LOGO,
  CDN,
  ENV,
  EXAPI,
  EXAPI1
}



// WEBPACK FOOTER //
// ./src/common/config.js